import {getRequest, postRequest, putRequest, toQueryString} from "./request";
import { ClientMe } from "../common/types/user";
import {Auth, signInWithCustomToken} from "firebase/auth";

export const GUEST_TOKEN_KEY = "guest-authorization";
export const GUEST_ID_API = "guestIdApi";
export const signupApi = async ({
  payload,
}: {
  payload: any;
}): Promise<any> => {
  return await postRequest<any>(`auth/register`, payload);
};

export const loginApi = async ({ payload }: { payload: any }): Promise<any> => {
  return await postRequest<any>(`auth/login`, payload);
};

export const meApi = async (): Promise<ClientMe> => {
  return await getRequest<ClientMe>("me").then((res) => res.data);
};

export const guestLoginApi = async (): Promise<any> => {
  return await postRequest<any>("auth/guest/login", {}).then((res) => res.data);
}

export const getProvider = async (email: string): Promise<any> => {
  return await postRequest<any>("users/provider", {email}).then((res) => res.data);
}

export const guestUserTransferApi = async (firstName?: string, lastName?: string): Promise<any> => {
  return await postRequest<any>("users/transfer", {firstName, lastName}, {baseURL: process.env.REACT_APP_SERVER_API?.replace("client", "guest")})
      .then((res) => res.data)
      .catch((err) => console.error(err));
}

export const signedUrlApi = async (params: any): Promise<string> => {
  const {contentType, fileName, config} = params;
  return await getRequest<string>(`users/signed-url?${toQueryString({ contentType, fileName })
  }`, undefined, config).then(res => res.data);
}

export const updateUserImageApi = async ({payload, userId}: {payload: any, userId: any}): Promise<any> => {
  return await putRequest<any>(`users/${userId}`, payload).then(res => res.data);
}

export const validateTokenApi = async (token: string): Promise<any> => {
  return await getRequest<any>('auth/validate-token', undefined, {
    skipFirebaseAuth: true,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }).then((res) => res.data);
}

export const getNewToken = async (uid: string,token:string): Promise<any> => {
  return await getRequest<any>(`get-token/get_new_token?uid=${uid}`, undefined, {
    skipFirebaseAuth: true,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }).then((res) => res.data);
}

export const signInWithToken = async (auth: Auth, token: string): Promise<void> => {
  const validationResult = await validateTokenApi(token);
  const newToken = await getNewToken(validationResult.uid, token);
  await signInWithCustomToken(auth, newToken);
  await auth.authStateReady();
}

